/* global axios */
import ApiClient from './ApiClient';

class TalkviaSuppliersAPI extends ApiClient {
  constructor() {
    super('talkvia_suppliers', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  list(params = {}) {
    return this.get(params);
  }

  create(supplier) {
    return axios.post(this.url, { supplier });
  }

  update(id, supplier) {
    return axios.patch(`${this.url}/${id}`, { supplier });
  }
}

export default new TalkviaSuppliersAPI();
